module.exports = "./img/desktop_logo.3973531.png";